"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = input => {
  let lastInput = input;

  while (true) {
    const result = lastInput // 2019-02-12T00:00:00
    .replace(/(\d+)T(\d+)/, '$1 $2').replace(/(\d+)\s\/\s(\d+)/, '$1/$2') // Ignore commas to capture formats such as 'Monday 20, May
    .replace(/,/g, ' ').replace(/[.:;] /g, ' ').replace(/\s+/g, ' ').trim();

    if (result === lastInput) {
      return result;
    }

    lastInput = result;
  }

  throw new Error('Unexpected state.');
};

exports.default = _default;
//# sourceMappingURL=normalizeInput.js.map